import React from 'react';
import PropTypes from 'prop-types';

import FeatureProvider from 'providers/FeatureProvider';
import AccessManagementRole from 'providers/AccessManagementRole';
import AccessManagementSection from 'providers/AccessManagementSection';
import AccessManagementPermission from 'providers/AccessManagementPermission';
import AccessManagementUserRole from 'providers/AccessManagementUserRole';
import AccessManagementeApplication from 'providers/AccessManagementApplication';
import Compose from 'providers/ProviderComposer';

function Providers({ children, features }) {
  return (
    <FeatureProvider features={features}>
      <Compose
        components={[
          AccessManagementPermission,
          AccessManagementRole,
          AccessManagementSection,
          AccessManagementUserRole,
          AccessManagementeApplication,
        ]}>
        {React.Children.only(children)}
      </Compose>
    </FeatureProvider>
  );
}
Providers.propTypes = {
  children: PropTypes.node,
  features: PropTypes.array,
};
export default Providers;
